import { ApplicantControllerStepView } from "./applicant-controller-step-view";
import { useApplicantControllerStep } from "./use-applicant-controller-step";

export default function ApplicantControllerStep() {
  const logic = useApplicantControllerStep();

  return <ApplicantControllerStepView {...logic} />;
}
